import { dataToExecData, ExecPrivilegedArgBase, } from '../ExecPrivilegedArgBase.js';
/**
 * @category Contract Exec Arguments
 */
export default class ExecPrivilegedArgVaultRedeem extends ExecPrivilegedArgBase {
    static fromJSON(params) {
        return new ExecPrivilegedArgVaultRedeem(params);
    }
    toData() {
        const { params } = this;
        return {
            vault_subaccount_id: params.vaultSubaccountId,
            trader_subaccount_id: params.traderSubaccountId,
            msg: {
                redeem: params.args,
            },
        };
    }
    toExecData() {
        const { params } = this;
        return dataToExecData(this.toData(), {
            origin: params.origin,
            name: 'VaultRedeem',
        });
    }
}
